module.exports = __webpack_public_path__ + "static/media/sign_bush.a2cc4d14.svg";